import styled from 'styled-components';
import { getTextColor } from '@magalu/stereo-ui-styles';
import Box from '../../atoms/Box';
export { ContainerInput, Input } from '../SearchInput/InputContainer/input-container.styles';
export const Wrapper = styled(Box)`
  border: solid 1px ${props => getTextColor('lighter')(props)};
  border-radius: 2px;
`;